import { render, staticRenderFns } from "./LbaDialogPopup.vue?vue&type=template&id=fa1517f2"
import script from "./LbaDialogPopup.vue?vue&type=script&lang=js"
export * from "./LbaDialogPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports